import React from 'react'
import { TableRow, TableCell } from 'transfix-ui/components/Table'
import { makeStyles, Box } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { getColumns } from '../../columns'

const useSavedLanesTableEmptyStyles = makeStyles({
  empty: {
    padding: '14px',
    textAlign: 'center',
    backgroundColor: brandColors.coolGray1,
    color: brandColors.coolGray5,
  },
})
export const SavedLanesTableEmpty = () => {
  const classes = useSavedLanesTableEmptyStyles()
  const refactoredSavedLanesCreateAndUpdateEnabled = useFeatureFlag(
    'refactoredSavedLanesCreateAndUpdate'
  )
  const tableColumns = getColumns(refactoredSavedLanesCreateAndUpdateEnabled)
  const tableColumnsCount = Object.keys(tableColumns).length

  return (
    <TableRow>
      <TableCell colSpan={tableColumnsCount + 1} dataTest='saved-lanes-table-empty'>
        <Box className={classes.empty} my={1}>
          No saved lanes
        </Box>
      </TableCell>
    </TableRow>
  )
}
